import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-navy/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-314" data-mp="2nvnf5h3e3ihq">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-315" data-mp="2svrs4x539v37">
        <div data-id="element-316" data-mp="2stownxl639r3">
          <p className="font-heading text-sm font-bold text-white" data-id="element-317" data-mp="o0kzqckphyfn">17,99€</p>
          <p className="text-[11px] text-white/70" data-id="element-318" data-mp="o2eao42cr4tg">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" showArrow={false} href={CHECKOUT_URL} data-id="element-319" data-mp="s2ono0okavht">
          Quiero EF-FLASH
        </PrimaryButton>
      </div>
    </div>;
}